import React from "react";

export default function Kbd({ text }: { text: string }) {
	return <kbd>{text}</kbd>;
}
